<style media="screen">

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        padding-top: 71px;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    input[type=file] {
        display: none;
    }

</style>

<template>

    <el-row>
        <el-form :model="bannerForm" :rules="rules" addAction="/group/news/addNews.action" editAction="/group/news/editNews.action"
                 label-width="100px" ref="bannerForm" selectAction="/group/news/getNews.action" v-form>

            <h3>
                发布群发广告
            </h3>
            <el-col :span="18" class="basic-margin">

              <el-form-item label="标题" label-position="left" prop="title">
                <el-input  :autosize="{ minRows:3 , maxRows:10}" placeholder="输入简要标题（建议500字以内）" type="textarea" v-model="bannerForm.title">
                </el-input>
              </el-form-item>

                <el-form-item style="margin-top: 100px" label="封面图片" label-position="top" prop="coverImgURL">
                    <el-upload :action="baseUrl+'upload/uploadPic'" :data="{floder:'news'}" :show-file-list="false"
                               accept="image/*" class="avatar-uploader" v-model="bannerForm.coverImgURL">
                        <img :src="bannerForm.coverImgURL.url" class="avatar" v-if="bannerForm.coverImgURL">
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    </el-upload>
                </el-form-item>


                <el-form-item class="basic-margin">
                    <el-button type="primary">保存</el-button>
                    <el-button @click="back()">取消</el-button>
                </el-form-item>
            </el-col>
        </el-form>

    </el-row>

</template>

<script>

import ChannelModel from '@/framework/models/channelModel'
import NewsModel from '@/framework/models/newsGroupModel'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import { quillEditor } from 'vue-quill-editor'
import { quillRedefine } from 'vue-quill-editor-upload'
import BrandAndSeriesCategoriesSelect from "@/components/BrandAndSeriesCategoriesSelect.vue";
export default {
  name: 'add-thematic-dialog',
  extends: BasicPager,
  data: function () {
    return {
      checkAll: false,
      visible: false,
      imageUrl: '',
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      targetDbtResult: 1,
      channelOptions: [],
      bannerForm: {
        id: null,
        type: 2,
        link: '',
        title: '',
        content: '',
        target: null,
        channelId: [],
        coverImgURL: null,
        createType: null,
        createPerson: null,
        channelKey: null
      },
      rules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        target: [{
          required: true,
          message: '请选择广告位类型',
          trigger: 'blur'
        }],
        coverImgURL: [{
          required: true,
          message: '请上传封面图片',
          trigger: 'change'
        }]
      }
    }
  },
components: {
  BrandAndSeriesCategoriesSelect,
      quillEditor,
      quillRedefine
},
  created: function () {
    // 获取参数
    let params = this.$route.params
    if (params) {
      this.bannerForm.id = params.id
    }
    this.editorOption = quillRedefine({
          toolOptions: [],
          // 以下所有设置都和vue-quill-editor本身所对应
          placeholder: '请输入内容', // 可选参数 富文本框内的提示语
          theme: '', // 可选参数 富文本编辑器的风格
          handlers: {} // 可选参数 重定义的事件，比如link等事件
        }
    )

    let loginInfo = this.loginInfo
    this.bannerForm.channelId = loginInfo.loginPath == 'cxh' ? this.bannerForm.channelId : [loginInfo.id]
    this.bannerForm.createType = loginInfo.loginPath == 'cxh' ? 1 : 2,
    this.bannerForm.createPerson = loginInfo.realName

  },
  methods: {

    onFilterParams: function (params) {
      params.channelKey = this.bannerForm.channelId.join(',')
    },
    selectControoler: function () {
      let _this = this
      let temp = []
      let channelstr = this.bannerForm.channelId.toString()
      if (channelstr.indexOf(-1) > -1) {
        for (var item of _this.channelOptions) {
          if (item.value == -1) {
            continue
          }
          temp.unshift(item.value)
        }

        this.bannerForm.channelId = temp
      }
    },
    submitForm: function () {
      let _this = this
      let loginInfo = _this.loginInfo
      _this.bannerForm.channelId = loginInfo.loginPath == 'cxh' ? _this.bannerForm.channelId : [loginInfo.id]
      let params = {
        channelKey: _this.bannerForm.channelId.join(','),
        title: _this.bannerForm.title,
        coverImg: _this.imageUrl,

        link: _this.bannerForm.link,
        type: _this.bannerForm.type,
        target: 1,
        createType: loginInfo.loginPath == 'cxh' ? 1 : 2,
        createPerson: loginInfo.realName
      }

      let listener = {
        success: function (dataInfo) {
          _this.visible = false
          _this.$emit('handleAddSuccess', dataInfo)
          _this.$message({
            message: '添加成功',
            type: 'success'
          })
          $router.push({ path: '/home/thematicGroupManagement' })
        }
      }
      NewsModel.addNews(this, params, listener)
    },
    back: function () {
      this.$router.back(-1)
    }
  }
}

</script>
